<dff-form-control [formControl]="formGroup.get('maalerNr.aktuel')">
    <button mat-icon-button matSuffix (click)="toggleAlphaNumeric()">
        <mat-icon [svgIcon]="isAlphaNumeric() ? 'alphanumeric' : 'alphanumeric-off'"></mat-icon>
    </button>
</dff-form-control>
<dff-form-control [formControl]="formGroup.get('maalerTypeId.aktuel')"></dff-form-control>
<maaler-aflaesning [formGroup]="formGroup"></maaler-aflaesning>
